export default __webpack_public_path__ + "static/torres-7cace0449e51190a5481f825425e545b.png";